import React from "react";
import "./Slider.scss";
import { SpeedSelector } from "./SpeedSelector";
import { AutoSizer } from "react-virtualized";
import { TimeSlider } from "./TimeSlider";
import "./TimeSelector.scss";
export const TimeSelector = ({ onChange, value, min, max, onPause, onPlay, onChangeSpeed, speed, isPaused, onReverse, onLive, canUseLive, }) => {
    return (React.createElement("div", { style: { display: "flex" } },
        React.createElement("div", { className: "time-selector-box" },
            React.createElement(SpeedSelector, { max: 200000, min: 1, value: speed, onReverse: onReverse, onPause: onPause, onPlay: onPlay, onChange: onChangeSpeed, isPaused: isPaused, canUseLive: canUseLive, onLive: onLive })),
        React.createElement("div", { style: { flex: "1" } },
            React.createElement(AutoSizer, null, ({ width, height }) => (React.createElement(TimeSlider, { onChange: onChange, width: width, height: height, min: min, max: max, value: value }))))));
};
//# sourceMappingURL=TimeSelector.js.map